import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type OptionItem = { label: string; value: number; default?: boolean };

export const useTranslateDuration = (list?: OptionItem[]) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      list?.map((item) => ({
        ...item,
        label: t("{{second}}s", { second: item.value }),
      })) ?? [],
    [list, t],
  );
};
